import { render } from "./SocialLinks.vue?vue&type=template&id=76db1192&scoped=true"
import script from "./SocialLinks.vue?vue&type=script&lang=js"
export * from "./SocialLinks.vue?vue&type=script&lang=js"

import "./SocialLinks.vue?vue&type=style&index=0&id=76db1192&scoped=true&lang=css"

import exportComponent from "/Users/adamchaarawi/Desktop/dev/adams-personal-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76db1192"]])

export default __exports__